import { useSignUpState, useUpdateSignUpState } from 'state/sign-up';
import { useSignInState } from 'state/sign-in';
import { useMutation } from 'react-query';
import { SingUpRequest } from 'api/auth';
import { api } from 'api/api';
import { useCallback, useEffect } from 'react';
import { showToastError, onError } from 'global/index';
import { useNavigate } from 'react-router';
import { RoutesSettings } from 'config/routes';

export const useSignUp = () => {
  const navigate = useNavigate();
  const update = useUpdateSignUpState();
  const { remoteValidationError, signUpStatus } = useSignUpState();
  const { username } = useSignInState();

  const { isLoading, mutate } = useMutation(async (request: SingUpRequest) => api.auth.signUp(request), {
    onError,
    onSuccess: response => {
      if (!response.hasError()) {
        update.successSignUp();
        return;
      }

      const { errorType } = response?.data;

      if (errorType === 'duplicatedUser') {
        update.errorSignUp();
        return;
      }

      if (errorType === 'forbidden') {
        update.forbiddenSignUp();
        return;
      }

      if (errorType === 'validation') {
        update.setRemoteValidationError(response.data?.message || '');
        return;
      }

      showToastError(response?.data?.message);
    },
  });

  const onSignUp = useCallback(rut => {
    update.setRut(rut);
    mutate({ rut, username });
  }, []);

  useEffect(() => {
    if (!username) {
      navigate(RoutesSettings.signIn, { replace: true });
    }
  }, [username, navigate]);

  useEffect(
    () => () => {
      update.reset();
    },
    [],
  );

  return {
    isLoading,
    onSignUp,
    remoteValidationError,
    resetRemoteValidatorError: update.setRemoteValidationError,
    signUpStatus,
  };
};
